export const images={
    plus:require('./plus.svg'),
    startPoint:require('./startPoint.png'),
    endPoint:require('./endPoint.png'),
    aeroplaneIcon:require('./airplane.png'),
}

// aeroplaneIcon:require('./aeroplane.png'),
